<template>
    <div class="wing_container">

        <div class="space">space</div>

        <div>
            <div style="text-align:center;" class="game_logo">
                <img src="../assets/img/game_logo.png" width="180" style="margin:0px 30px;">
            </div>

            <div class="layout_mobile">
                <div @click="toMyPage" class="my_page">
                    <img src="../assets/img/btn_my_page.png" width="180">
                </div>
                <div @click="toMyPage" class="my_page_mobile">
                    <img src="../assets/img/face_mypage.png" width="30"> 팩트체커 기록
                </div>


                <div class="time_score_container">
                    <div class="flex_item">
                        <img src="../assets/img/icon_time.png" width="23">
                        <span>{{currentTime}}</span>
                    </div>

                    <div class="flex_item">
                        <img src="../assets/img/icon_score.png" width="23">
                        <span>{{score}}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 데스크탑용 -->
        <div class="index_table">
            <div class="index_table_title">팩트체크 진행 순서</div>
            <div v-for="(p, index) in phase" :key="p.idx">
                <div :class="p.cls" @click="touchItem(index)">{{p.title}}</div>
                <div v-if="index != phase.length - 1" class="bar">&gt;</div>
            </div>
        </div>

        <!-- 모바일용 -->
        <div class="mobile_title_container">
            <div class="phase_title" @click="toBack">
                <div :class="(index == 0 || index == 4 || index == 5 || index == 6) ? 'invisible' : ''">
                    <img src="../assets/img/button_back.png" width="25">
                </div>
                <div class="title_text">{{phaseMobile[index].title}}</div>
            </div>
            <div class="phase_desc">{{phaseMobile[index].desc}}</div>
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'RightWingView',

    props: {
        index: Number,
        score: Number
    },
    
    data() {
        return {
            timerId: null,
            start_time: 0,
            currentTime: '00:00',

            phase: [
                {idx: 0, title: '① 영역선택', cls:['item', 'inactive']},
                {idx: 1, title: '② 주제선택', cls:['item', 'inactive']},
                {idx: 2, title: '③ 근거수집', cls:['item', 'inactive']},
                {idx: 3, title: '④ 최종 팩트 판결', cls:['item', 'inactive']},
                {idx: 4, title: '⑤ 팩트 점검', cls:['item', 'inactive']},
                {idx: 5, title: '⑥ 전문가 확인', cls:['item', 'inactive']},
                // {idx: 6, title: '최종 결과 확인', cls:['item', 'inactive']},
            ],

            phaseMobile: [
                {idx: 0, title: '1단계 영역선택', desc: this.$i18n.t('title_section_view'), cls:['item', 'inactive']},
                {idx: 1, title: '2단계 주제선택', desc: '팩트체크 하고 싶은 주제를 선택하세요', cls:['item', 'inactive']},
                {idx: 2, title: '3단계 근거수집', desc: '주제의 근거를 확인해 수집하세요.', cls:['item', 'inactive']},
                {idx: 3, title: '4단계 최종 팩트 판결', desc: '주제가 사실인지 확인하세요.', cls:['item', 'inactive']},
                {idx: 4, title: '5단계 팩트 점검', desc: '점검 결과를 확인하세요.', cls:['item', 'inactive']},
                {idx: 5, title: '6단계 전문가 확인', desc: '전문가의 이야기를 들어보세요.', cls:['item', 'inactive']},
                {idx: 6, title: '최종 결과 확인', desc: '플레이 기록을 확인하세요.', cls:['item', 'inactive']},
            ]
        }
    },

    mounted() {
        this.start_time = this.$getCurrentGame().start_time

        let delta = (30 * 60) - ((Date.now() - this.start_time) / 1000)
        if(delta <= 0) {
            this.currentTime =  '00:00'
            // 이미 해당 페이지일때는 안 함
            if(this.$router.currentRoute.path == '/finalResult') {
                return
            }
            this.$router.push('/finalResult')
        }
        else {
            this.timerId = setInterval(() => {
                this.getCurrentTime()
            }, 1000);

            // PC에서 어느 단계인지 표시한다
            for(let i = 0; i < this.phase.length; i++) {
                if(i == this.index) {
                    this.phase[i].cls = ['item', 'active']
                }
            }
        }
    },

    beforeDestroy() {
        clearInterval(this.timerId)
    },

    methods: {
        getCurrentTime: function() {
            let delta = (30 * 60) - ((Date.now() - this.start_time) / 1000)
            if(delta <= 0) {
                this.currentTime =  '00:00'
                // 이미 해당 페이지일때는 안 함
                if(this.$router.currentRoute.path == '/finalResult') {
                    return
                }
                this.$router.push('/finalResult')
            }
            else {
                let min = parseInt(delta / 60)
                if(min - 10 < 0) {
                    min = '0' + min
                }
                let sec = parseInt(delta % 60)
                if(sec - 10 < 0) {
                    sec = '0' + sec
                }
                this.currentTime =  min + ':' + sec
            }
        },

        touchItem: function(index) {
            console.log(index)

            // 애매함. 일관성이 없음
            // if(index == 0) {
            //     this.$router.push('/sectionList')
            // }
            // else if(index == 1 && this.index > index) {
            //     this.$router.push('/articleList')
            // }
            // else if(index == 2 && this.index > index) {
            //     this.$router.push('/clueList3')
            // }
        },

        toMyPage: function() {
            this.$router.push('/finalResult')
        },

        toBack: function() {
            if(this.$router.currentRoute.path == '/articleList') {
                this.$router.push('/sectionList')
            }
            else if(this.$router.currentRoute.path == '/clueList3') {
                this.$router.push('/articleList')
            }
            else if(this.$router.currentRoute.path == '/clueDetail3') {
                this.$router.push('/clueList3')
            }
            else if(this.$router.currentRoute.path == '/selectTrueOrNot') {
                this.$router.push('/clueList3')
            }
            // if(this.index == 1) {
            //     this.$router.push('/sectionList')
            // }
            // else if(this.index == 2) {
            //     this.$router.push('/articleList')
            // }

            // this.$router.go(-1)

        }
    }
}
</script>

<style scoped>
.flex_item {
    width:100px;
    text-align:center;
    font-size:16px;
}
.invisible {
    opacity: 0;
}

/* pc */
@media screen and (min-width: 415px) {
    .wing_container {
        background-color: white;
        width: 240px;
        /* height: 620px; */
        height: 100vh;
        border-right: 1px solid black;
        /* border-bottom: 1px solid black; */
        /* box-shadow:2px 2px 2px grey; */
    }
    .game_logo {
        text-align: center;
    }
    .bar {
        text-align: center;
        /* background-color: aqua; */
        color:#A8A8A8;
        transform: rotate(90deg);
        font-size: 15px;
        font-weight: 700;
        width:14px;
        margin-left:50px;
        margin-top:-10px;
        margin-bottom:-10px;
    }
    .item {
        margin: 10px;
        padding-left: 10px;
        padding-top: 5px;
        padding-bottom: 5px;
    }
    .active {
        background-color:black;
        color:white;
        font-weight: 700;
    }

    .inactive {
        color:#A8A8A8;
    }
    .index_table {
        margin-top:20px;
        background-color:#f5f5f5;
        padding:10px 5px;
        margin: 0px 10px;
    }
    .time_score_container {
        text-align: center;
        margin:20px 10px;
        display:flex;
        justify-content:space-around;
    }
    .my_page {
        text-align:center;
        margin-top:20px;
        cursor:pointer;
    }
    .space {
        opacity:0; font-size:10px;
    }
    .index_table_title {
        text-align: center;
        font-weight: 700;
        font-size: 20px;
    }
    .mobile_title_container {
        display: none;
    }
    .my_page_mobile {
        display: none;
    }
}

/* mobile */
@media screen and (max-width: 414px) {
    .wing_container {
        width: 100%;
        /* height: 60px; */
        border-bottom: 2px solid black;
    }
    .index_table {
        display: none;
    }
    .game_logo {
        display: none;
    }
    .time_score_container {
        padding: 10px;
        text-align: center;
        display:flex;
        justify-content:space-around;
    }
    .my_page {
        display: none;
    }
    .my_page_mobile {
        font-size: 16px;
        font-weight: 700;
    }
    .space {
        display: none;
    }
    .mobile_title_container {
        background-color: black;
        color:white;
        padding: 10px;
    }
    .phase_title {
        font-size: 24px;
        display: flex;
        margin-bottom: 10px;
        align-items: center;
    }
    .phase_desc {
        font-size: 17px;
        text-align: center;
    }
    .title_text {
        flex-grow: 1;
        text-align: center;
        margin-left: -30px;
        /* background-color: #ffffff55; */
    }
    .layout_mobile {
        display: flex;
        align-items: center;
        justify-content: center;
        justify-items: center;
    }
}
</style>
